import React, {useState, useEffect,useRef,Fragment} from 'react';
import '../assets/css/select_mult.css';

/**
 *Crea un select múltiple para el uso en filtros
 * distVal: array con los valores a mostrar
 * valores: string con los valores seleccionados separados por comas
 * alCambiar: función que se ejecutará al cambiar los valores 

 */


const SelectMult = (props) => {
	const [visSelec,setVisSelec]=useState(false)// si se ve desplegado el select múltiple
	// const [selValMues,setSelValMues]=useState('');
	const [selValMues,setSelValMues]=useState('');

	const selValMult=useRef();

	//efect para llevar el foco al select multiple cuando se pincha para mostrar
	useEffect(()=>{
		if (props.distVal)
			selecAplic(props.valores)
		setSelValMues(selecVis(props.valores))
		// eslint-disable-next-line
	},[props.distVal])

	useEffect(()=>{
		if (visSelec)
			selValMult.current.focus()
	},[visSelec])

	// devuelve como se deben visualizar los campos, dándole todos separados por comas
	function selecVis(valor){
		if (valor==='')
			return('')
		const ar=valor.split(", ")
		let n=0
		let s=''
		const maxCadena=44 // el texto máximo que queremos que se muestre
		for (let elem in ar){
			if (n===0 | `${s},'${ar[elem]}' ... (${(ar.length-n)} más)`.length<maxCadena)
				s+=`${ar[elem]}`
			else{
				s+="... ("+(ar.length-n)+' más)'
				return (s)
			}
			n++;
			if (n<ar.length)// hay más elementos por meter
				s+=', '
		}
		return (s)
	}

	// Metemos los valores en el selec múltiple
	function selecAplic(valores){
		valores=valores.substring(1,valores.length-1)
		const ar=valores.split(", ")
		let n=0
		for (let elem of selValMult.current.options) {
			elem.selected=false
			for (let a of ar)
				if (elem.value===a)
					elem.selected=true
			if (props.disabled)
				if (props.disabled[n])
					elem.disabled=true
			if (props.estilo)
				if (props.estilo[n])
					elem.style=props.estilo[n]
			n++
		}
	}

	return ( 
		<Fragment>
			<div className='col-xs-12'>
				<input 
					onClick={()=>{setVisSelec(true);}}
					className='select_multiple_input'		
					type="text"
					defaultValue={selValMues}
				/>
			</div>
			<div className='col-xs-12'>
			<select multiple className='select_multiple' 
				ref={selValMult}
				onChange={
					()=>{
						let arr=[]
						let arr2=[]
						for (const elem of selValMult.current.selectedOptions) {
							arr.push(elem.value)
							arr2.push(elem.label)
						}
						let s=arr.join(', ')
						// s=s.slice(1);
						// s=s.slice(0, -1);

						let s2=arr2.join(', ')
						// s2=s2.slice(1);
						// s2=s2.slice(0, -1);

						props.alCambiar(s, s2);

						setSelValMues(s2);
						// setSelValMues(s);
					}
				}
				onBlur={()=>{setTimeout(function(){setVisSelec(false)},100)}}
				style={{visibility:(visSelec?'visible':'hidden')}}>
				{	props.distVal&& 
						props.distVal.map((elem,id)=>(
							// <Fragment key={elem}>
							// 	{props.campo=="Usuario" || props.campo=="Departamento" || props.campo=="Empresa" ?
							// 		(
							// 		<option 
							// 			value={elem.valor}
							// 			label={elem.titulo}
							// 			key={id}>{elem.titulo}
							// 		</option>
							// 		):(
							// 		<option 
							// 			value={elem.valor}
							// 			label={elem.titulo}
							// 			key={id}>{elem.titulo}
							// 		</option>
							// 		)
							// 	}
							// </Fragment>

							<option 
								value={elem.valor}
								label={elem.titulo}
								key={id}>{elem.titulo}
							</option>
							
						))
				}
			</select>
			</div>
		</Fragment>

	 );
}
 
export default SelectMult;